import { Box, CardContent, CardHeader, Paper, Slide } from '@mui/material';
import styles from './ccf-copilot-video-call.module.scss';
import React from 'react';
import { CcfBox, CcfTypography } from '@nice-ccf/ui-controls';
import { Close } from '@mui/icons-material';
import CcfCopilotCRMDashboard from './ccf-copilot-crmdashboard/ccf-copilot-crmdashboard';

/* eslint-disable-next-line */
export interface CcfCopilotVideoCallProps {}
/**
 * CcfCopilot - used to display Copilot tab in App Space
 * @param props -?-CcfCopilotProps
 * @example <CcfCopilot />
 */
export function CcfCopilotVideoCall(props: CcfCopilotVideoCallProps) {
  const [checked, setChecked] = React.useState(false);
  const [playVideo, setPlayVideo] = React.useState(false);
  const containerRef = React.useRef(null);
  const videoPlayer = React.useRef<HTMLVideoElement>(null);
  /**
   * closeVideo - used to stop video
   * @param props -?-NA
   * @example closeVideo()
   */
  const closeVideo = () => {
    setChecked(false);
    videoPlayer?.current?.pause();
  };

  /**
   * closeVideoOnSetTime - used to stop video at specific time
   * @param props -?-NA
   * @example closeVideoOnSetTime()
   */
  const closeVideoOnSetTime = () => {
    videoPlayer?.current &&
      videoPlayer?.current?.currentTime > 11 &&
      closeVideo(); //stop the video after 10 seconds
  };

  const icon = (
    <Paper
      sx={{ m: 1, width: 400, height: 300 }}
      elevation={4}
      style={{ position: 'absolute', left: '500px' }}
    >
      <CcfBox id="agent_videopopup_parentContainer"  component="div" sx={{ width: 'inherit', height: 'inherit' }}>
        <CcfBox className={styles.closeBtn}>
          <CcfTypography className={styles.videoCallCaption}>
            New Video Call
          </CcfTypography>
          <Close id="agent_videoCall_closeVideoIcon"  onClick={closeVideo} style={{ cursor: 'pointer' }} />{' '}
        </CcfBox>
        {playVideo && (
          <CcfBox id="agent_videoCall_streamVideo" sx={{ width: 'inherit', height: '89%' }}>
            <video
              controls
              autoPlay
              onEnded={closeVideo} //close the video Modal after completion of Video
              onTimeUpdate={closeVideoOnSetTime} //close the Video after 10 seconds set time
              style={{
                width: '-webkit-fill-available',
                height: '-webkit-fill-available',
              }}
              ref={videoPlayer}
            >
              <source src="./assets/VideoCall.mp4" type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          </CcfBox>
        )}
      </CcfBox>
    </Paper>
  );

  React.useEffect(() => {
    setTimeout(() => {
      setChecked((prev) => !prev);
      setPlayVideo((prev) => !prev);
    }, 3000);
  }, []);

  return (
    <CcfBox
      sx={{
        height: '100%',
        width: '100%',
        display: 'flex',
        padding: 'none',
        borderRadius: 1,
        // bgcolor: (theme) =>
        //   theme.palette.mode === 'light' ? 'grey.100' : '#fff',
        overflow: 'hidden',
      }}
    >
      <CcfBox
        sx={{
          height: '100%',
          width: '100%',
          display: 'flex',
        }}
        ref={containerRef}
      >
        {/* <img
          style={{ height: '100%', width: '100%' }}
          alt="CopilotVideoCallCRM"
          src="./assets/CopilotVideoCallCRM.png"
        /> */}

        <CcfCopilotCRMDashboard />

        <Slide
          direction="right"
          in={checked}
          container={containerRef.current}
          timeout={1500}
        >
          {icon}
        </Slide>
      </CcfBox>
    </CcfBox>
  );
}

export default CcfCopilotVideoCall;
